<template>
  <div>
    <div class="right-1">
      <div>
        <div class="right-title-1 right-title-2">
          <div>姓名</div>
          <div>
            <el-select
              v-model="addForm.yptCustomerId"
              filterable
              remote
              v-if="setTitle === '新增'"
              style="width: 100%"
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @change="handleSelect"
              :disabled="setTitle === '查看' || setTitle === '编辑'"
              @click.native="clearForm"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              disabled
              v-else
              v-model="addForm.customerName"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="right-title-1">
          <div>性别</div>
          <div style="display: flex; justify-content: center">
            <el-select
              disabled
              v-model="addForm.gender"
              placeholder="根据身份证号获取"
              size="medium"
              style="width: 100%"
            >
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="right-title-1">
          <div>手机号码</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              disabled
              v-model="addForm.phone"
              size="medium"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="right-title-1">
          <div>家庭电话</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              v-model="addForm.familyCall"
              size="medium"
              placeholder="请输入"
              disabled
            ></el-input>
          </div>
        </div>
        <div class="right-title-1">
          <div>民族</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              v-model="addForm.nation"
              size="medium"
              placeholder="请输入"
              disabled
            ></el-input>
          </div>
        </div>
        <div class="right-title-1">
          <div>用户类型</div>
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              :content="addForm.customerTypeStr"
              placement="bottom-start"
            >
              <el-select
                @change="wCustomerInfo"
                v-model="addForm.customerType"
                placeholder="请选择"
                class="overs"
                size="medium"
                v-if="setTitle === '新增'"
                multiple
                style="width: 100%"
                disabled
              >
                <el-option
                  v-for="(item, index) in userType"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="addForm.customerTypeStr"
                placeholder="请输入关键词"
                disabled
                v-else
              ></el-input>
            </el-tooltip>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>所属类别</div>
          <div>
            <el-select
              @change="wCustomerInfo"
              v-model="addForm.elderlyBelongCategory"
              placeholder="请选择"
              size="medium"
              style="width: 100%"
              disabled
            >
              <el-option
                v-for="(item, index) in oldtypeLits"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode + ''"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div>
        <div class="right-title-1 right-title-2 right-title-3">
          <div>身份证号</div>
          <div>
            <el-select
              v-model="addForm.idCard"
              filterable
              remote
              style="width: 100%"
              placeholder="请输入关键词"
              :disabled="setTitle === '查看' || setTitle === '编辑'"
              :remote-method="remoteMethod1"
              @change="handleSelect"
              @click.native="clearForm1"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.idCard"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>出生日期</div>
          <div>
            <el-input
              disabled
              @blur="wCustomerInfo"
              v-model="addForm.birthday"
              size="medium"
              placeholder="根据身份证号获取"
            ></el-input>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>年龄</div>
          <div>
            <el-input
              disabled
              @blur="wCustomerInfo"
              v-model="addForm.age"
              size="medium"
              placeholder="根据身份证号获取"
            ></el-input>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>婚姻状态</div>
          <div>
            <el-select
              style="width: 100%"
              @change="wCustomerInfo"
              v-model="addForm.marriageStatus"
              placeholder="请选择"
              size="medium"
              disabled
            >
              <el-option
                v-for="item in marriageList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>生活区域</div>
          <div>
            <el-select
              style="width: 100%"
              @change="wCustomerInfo"
              v-model="addForm.lifeArea"
              placeholder="请选择"
              size="medium"
              disabled
            >
              <el-option label="城市" :value="1"></el-option>
              <el-option label="农村" :value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>区域名称</div>
          <div>
            <el-cascader
              ref="orgId"
              :key="isRescourceShow"
              disabled
              :show-all-levels="false"
              v-model="addForm.dataId"
              style="width: 100%"
              :options="quyuList"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'label',
                value: 'orgId',
              }"
              clearable
            >
            </el-cascader>
          </div>
        </div>
        <div class="right-title-1 right-title-3">
          <div>所属机构</div>
          <div>
            <el-select
              v-model="addForm.serviceStation"
              placeholder="请选择"
              size="mini"
              style="width: 100%"
              disabled
            >
              <el-option
                v-for="item in serviceStationList"
                :key="item.selectTreeId"
                :label="item.statName"
                :value="item.selectTreeId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div>
        <div class="right-2">
          <div>
            <el-upload
              v-if="codeState == false"
              :action="baseUrl"
              disabled
              :show-file-list="false"
              class="avatar-uploader"
              :on-success="
                (file, fileList) => {
                  handleAvatarSuccess(file, fileList, 'add')
                }
              "
            >
              <img v-if="addForm.photo" :src="addForm.photo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <vue-qr
              v-if="codeState == true"
              :text="String(addForm.id)"
              :size="178"
            ></vue-qr>
            <div class="shangchuang2">
              <span class="item" @click="getPicture">上传照片</span>
              <div class="item item1" v-if="addForm.id" @click="getCode">
                二维码
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-1">
      <div>
        <div class="right-title-5 right-title-3">
          <div>政府援助信息</div>
          <div class="right-title-4">
            <div>
              <el-checkbox-group
                @change="changeGover"
                v-model="goverInfoId"
                disabled
              >
                <el-checkbox label="0">实体服务</el-checkbox>
                <el-checkbox label="1">信息服务 </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="right-title-5 right-title-3" style='height:50px'>
          <div style='height:50px;line-height:50px;'>居住情况</div>
          <div class="right-title-4" >
            <div>
              <el-radio-group
                @change="wCustomerInfo"
                v-model="addForm.liveCondition"
                disabled
              >
                <el-radio label="1">独居</el-radio>
                <el-radio label="8">双居</el-radio>
                <el-radio label="3">与子女长住 </el-radio>
                <el-radio label="4">与子女轮流居住 </el-radio>
                <el-radio label="5">与陪护人员居住 </el-radio>
                <el-radio label="6" style='margin-top:6px;'>与亲属朋友居住 </el-radio>
                <el-radio label="7" style='margin-top:6px;'>其他</el-radio>
                
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="right-title-5 right-title-3">
          <div>经济来源</div>
          <div class="right-title-4">
            <div>
              <el-checkbox-group
                @change="changeEconomicSource"
                v-model="economicSourceId"
                disabled
              >
                <el-checkbox label="0">养老金</el-checkbox>
                <el-checkbox label="1">子女供养 </el-checkbox>
                <el-checkbox label="2">救济优抚 </el-checkbox>
                <el-checkbox label="3">兼职</el-checkbox>
                <el-checkbox label="4">其他</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="right-title-6 right-title-3">
          <div>个人喜好</div>
          <div class="right-title-4">
            <div>
              <el-checkbox-group
                @change="checkedHobby"
                v-model="hobbyId"
                disabled
              >
                <el-checkbox label="棋牌">棋牌</el-checkbox>
                <el-checkbox label="舞蹈">舞蹈</el-checkbox>
                <el-checkbox label="诗词">诗词</el-checkbox>
                <el-checkbox label="戏曲">戏曲</el-checkbox>
                <el-checkbox label="钓鱼">钓鱼</el-checkbox>
                <el-checkbox label="书画">书画</el-checkbox>
                <el-checkbox label="收藏">收藏</el-checkbox>
                <el-checkbox label="摄影">摄影</el-checkbox>
                <el-checkbox label="旅游">旅游</el-checkbox>
                <el-checkbox label="唱歌">唱歌</el-checkbox>
                <el-checkbox label="手工">手工</el-checkbox>
                <el-checkbox label="健康养生">健康养生 </el-checkbox>
                <el-checkbox label="体育健身">体育健身 </el-checkbox>
                <el-checkbox label="其他">其他</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="right-title-7 right-title-3">
          <div>联系地址</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              size="mini"
              readonly
              v-model="addForm.address"
              disabled
            ></el-input>
          </div>
          <button
            @click="chioceDizhi"
            disabled
            style="border: 0; background: none"
          >
            <i class="el-icon-location-information colorIcon"></i>
          </button>
          <el-button
            type="primary"
            @click="cleatLat"
            class="clearBtns"
            :disabled="
              addForm.id == null || addForm.id == '' || setTitle === '查看'
            "
            style="
              height: 30px;
              line-height: 29px;
              padding: 0 12px;
              margin-left: 12px;
            "
            >清除经纬度
          </el-button>
        </div>
        <div class="right-title-7 right-title-3">
          <div>服务地址</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              size="mini"
              readonly
              v-model="addForm.serviceAddress"
              disabled
            ></el-input>
          </div>
          <button
            @click="chioceDizhi1"
            style="border: 0; background: none"
          >
            <i class="el-icon-location-information colorIcon"></i>
          </button>
          <el-button
            type="primary"
            @click="cleatLat1"
            class="clearBtns"
            :disabled="
              addForm.id == null || addForm.id == '' || setTitle === '查看'
            "
            style="
              height: 30px;
              line-height: 29px;
              padding: 0 12px;
              margin-left: 12px;
            "
            >清除经纬度
          </el-button>
        </div>
        <div class="right-title-9 right-title-3">
          <div>服务类别</div>
          <div class="right-title-4">
            <div>
              <el-checkbox-group
                @change="checkedGory"
                v-model="serviceCategory"
                :disabled="setTitle === '查看'"
              >
                <el-checkbox
                  v-for="item in serviceType"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.serviceTypeName }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="right-title-8 right-title-3">
          <div>备注</div>
          <div>
            <el-input
              @blur="wCustomerInfo"
              v-model="addForm.remark"
              size="mini"
              :rows="3"
              type="textarea"
              disabled
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-1">
      <div class="list-1">
        <div
          v-for="(unit, idx) in tapList"
          :key="idx"
          class="list-2"
          :class="{ change: tapId == unit.id }"
          @click="chioceId(unit.id)"
        >
          <div>{{ unit.name }}</div>
        </div>
      </div>

      <div v-show="tapId == 3" style="width: 100%">
        <div style="text-align: right; margin-bottom: 20px">
          <el-button @click="addUrgency" type="primary" size="small"
            >添加监护人
          </el-button>
        </div>
        <template>
          <div
            class="tap2-1"
            v-for="(item, index) in addForm.contact"
            :key="index"
          >
            <div>
              <div class="tap2-2">
                <div class="tap2-3">
                  <div>监护人：</div>
                  <div>
                    <el-input
                      @blur="wCustomerInfo"
                      v-model="item.contactName"
                      size="mini"
                      :disabled="setTitle === '查看'"
                    ></el-input>
                  </div>
                </div>
                <div class="tap2-3">
                  <div>联系电话：</div>
                  <div>
                    <el-input
                      @blur="wCustomerInfo"
                      v-model="item.phone"
                      size="mini"
                      :disabled="setTitle === '查看'"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-dialog
      title="定位信息"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
    >
      <el-form :disabled="setTitle === '查看'">
        <el-form-item label="联系地址：">
          <el-row>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  :disabled="
                    normalInfo.orgLevel == 1 ||
                    normalInfo.orgLevel == 2 ||
                    normalInfo.orgLevel == 3 ||
                    normalInfo.orgLevel == 4 ||
                    normalInfo.orgLevel == 5
                  "
                  v-model="addForm.provinceId"
                  placeholder="请选择省"
                  @change="handleProvince"
                  style="width: 100%"
                  ref="selectShengChange"
                >
                  <el-option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="
                  normalInfo.orgLevel == 2 ||
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5
                "
                v-model="addForm.cityId"
                placeholder="请选择市"
                @change="handleCity"
                ref="selectShiChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5
                "
                v-model="addForm.areaId"
                placeholder="请选择区"
                @change="handleArea"
                ref="selectQuChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5"
                v-model="addForm.streetId"
                placeholder="请选择街道"
                @change="streetChange"
                ref="selectJiedaoChange"
              >
                <el-option
                  v-for="(item, index) in streetList"
                  :key="index"
                  :label="item.addName"
                  :value="item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="normalInfo.orgLevel == 5"
                v-model="addForm.communityId"
                placeholder="请选择社区"
                ref="selectShequChange"
                @change="handleCommunityChange"
              >
                <el-option
                  v-for="item in communityList"
                  :key="item.addCode"
                  :label="item.addName"
                  :value="+item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <input
            v-model.trim="addForm.address"
            :disabled="setTitle == '查看'"
            id="tipinput"
            class="el-input__inner"
            :class="setTitle == '查看' ? 'innerCur' : ''"
            @focus="getMap('tipinput')"
            placeholder="请输入关键字"
            autocomplete="off"
          />
          <div class="map_container">
            <div
              class="map_right"
              id="container3"
              style="width: 100%; height: 300px"
            ></div>
          </div>
        </el-form-item>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
          "
        >
          <el-button @click="locationSend" type="primary">确定 </el-button>
          <el-button @click="locationClose" type="info">取消 </el-button>
        </div>
      </el-form>
    </el-dialog>
     <el-dialog
      title="定位信息"
      :visible.sync="dialogVisible1"
      width="50%"
      append-to-body
    >
      <el-form :disabled="setTitle === '查看'">
        <el-form-item label="联系地址：">
          <el-row>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  :disabled="
                    normalInfo.orgLevel == 1 ||
                    normalInfo.orgLevel == 2 ||
                    normalInfo.orgLevel == 3 ||
                    normalInfo.orgLevel == 4 ||
                    normalInfo.orgLevel == 5
                  "
                  v-model="addForm.provinceId1"
                  placeholder="请选择省"
                  @change="handleProvince"
                  style="width: 100%"
                  ref="selectShengChange"
                >
                  <el-option
                    v-for="(item, index) in provinceList"
                    :key="index"
                    :label="item.name"
                    :value="item.adcode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="
                  normalInfo.orgLevel == 2 ||
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5
                "
                v-model="addForm.cityId1"
                placeholder="请选择市"
                @change="handleCity"
                ref="selectShiChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="
                  normalInfo.orgLevel == 3 ||
                  normalInfo.orgLevel == 4 ||
                  normalInfo.orgLevel == 5
                "
                v-model="addForm.areaId1"
                placeholder="请选择区"
                @change="handleArea"
                ref="selectQuChange"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.addName"
                  :value="item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5"
                v-model="addForm.streetId1"
                placeholder="请选择街道"
                @change="streetChange"
                ref="selectJiedaoChange"
              >
                <el-option
                  v-for="(item, index) in streetList"
                  :key="index"
                  :label="item.addName"
                  :value="item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3" :offset="1">
              <el-select
                :disabled="normalInfo.orgLevel == 5"
                v-model="addForm.communityId1"
                placeholder="请选择社区"
                ref="selectShequChange"
                @change="handleCommunityChange"
              >
                <el-option
                  v-for="item in communityList"
                  :key="item.addCode"
                  :label="item.addName"
                  :value="+item.addCode"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <input
            v-model.trim="addForm.serviceAddress"
            :disabled="setTitle == '查看'"
            id="tipinput"
            class="el-input__inner"
            :class="setTitle == '查看' ? 'innerCur' : ''"
            @focus="getMap('tipinput')"
            placeholder="请输入关键字"
            autocomplete="off"
          />
          <div class="map_container">
            <div
              class="map_right"
              id="container3"
              style="width: 100%; height: 300px"
            ></div>
          </div>
        </el-form-item>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
          "
        >
          <el-button @click="locationSend" type="primary">确定 </el-button>
          <el-button @click="locationClose" type="info">取消 </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import "@/utils/addToolbar"
import AMap from "AMap" // 引入高德地图
import selectTree from "@/component/selectTree"
import vueQr from "vue-qr"
import exportVue from "@/utils/exportVue"
export default {
  props: {
    setTitle: {
      type: String,
      default: "",
    },
    formData: {},
  },
  components: {
    selectTree,
    vueQr,
  },
  data() {
    return {
      // 图片上传地址
      baseUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      checkList: [],
      tapId: "0",
      radio: "",
      marriageList: [
        {
          value: 1,
          label: "未婚",
        },
        {
          value: 2,
          label: "已婚",
        },
        {
          value: 3,
          label: "离婚",
        },
        {
          value: 4,
          label: "丧偶",
        },
        {
          value: 5,
          label: "初婚",
        },
        {
          value: 6,
          label: "再婚",
        },
        {
          value: 7,
          label: "复婚",
        },
      ],
      loading: false,

      nodata: "加载中",
      options: [],
      tapList: [
         {
          id: "3",
          name: "添加监护人",
        },
      ],
      hobbyList: [
        {
          value: "1",
          name: "棋牌",
        },
        {
          value: "2",
          name: "舞蹈",
        },
        {
          value: "3",
          name: "诗词",
        },
        {
          value: "4",
          name: "戏曲",
        },
        {
          value: "5",
          name: "钓鱼",
        },
        {
          value: "6",
          name: "书画",
        },
        {
          value: "7",
          name: "收藏",
        },
        {
          value: "8",
          name: "摄影",
        },
        {
          value: "5",
          name: "钓鱼",
        },
        {
          value: "6",
          name: "书画",
        },
        {
          value: "7",
          name: "收藏",
        },
        {
          value: "8",
          name: "摄影",
        },
        {
          value: "9",
          name: "旅游",
        },
        {
          value: "10",
          name: "唱歌",
        },
        {
          value: "11",
          name: "手工",
        },
        {
          value: "12",
          name: "健康养生",
        },
        {
          value: "13",
          name: "体育健身",
        },
        {
          value: "14",
          name: "其他",
        },
      ],
      hobbyId: [],
      serviceCategory: [],
      economicSourceId: [],
      goverInfoId: [],
      oldManId: [],
      expectPensionId: [],
      expectServiceId: [],
      familyContact: [],
      oldtypeLits: [],
      addForm: {
        address: "",
        familyContact: [
          {
            contactName: "1",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ],
        contact: [
          {
            contactName: "",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ],
        customerHealth: {},
        customerType: [],
        dataId: [],
        yptCustomerId: "",
      },
      dialogVisible: false,
      dialogVisible1:false,
      myMap: null,
      polygons: [],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      markers: [],
      isMap: false,
      provinceId: "", //省
      cityId: "", //市
      areaId: "", //区
      streetId: "", //街道
      communityId: "", //社区
      address: "",
      longitude: "",
      latitude: "",
      serviceAddress:'',
      serviceLatitude:'',
      serviceLongitude:'',
      selectTreeList: [],
      selectTreeId: "",
      serviceStationList: [],
      historyList: [],
      quyuList: [],
      isRescourceShow: 0,
      normalInfo: {},
      polygon: [],
      codeState: false,
      serviceType: [],
      userType: [],
      isServiceAddress:false
    }
  },
  watch: {
    quyuList() {
      ++this.isRescourceShow
    },
    formData: {
      handler(val) {
        exportVue.$emit("oldInfo", val.id)
        this.getTree()
        this.getServiceType().then((res) => {
          this.serviceType = res
          if (this.formData.id) {
            this.wCustomerInfo()
            this.addForm = val
            this.addForm.communityId = this.addForm.communityId
              ? this.addForm.communityId
              : ""

            this.addForm.type = this.addForm.type
              ? String(this.addForm.type)
              : ""
            this.addForm.area = this.addForm.area
              ? String(this.addForm.area)
              : ""

            if (this.addForm.serviceCategory != null) {
              this.serviceCategory = this.addForm.serviceCategory.split(",")
            }
            if (this.addForm.goverInfoId != null) {
              this.goverInfoId = this.addForm.goverInfoId.split(",")
            } else {
              this.goverInfoId = []
            }
            if (this.addForm.hobby != null) {
              this.hobbyId = this.addForm.hobby.split(",")
            } else {
              this.hobbyId = []
            }
            if (this.addForm.economicSource != null) {
              this.economicSourceId = this.addForm.economicSource.split(",")
            } else {
              this.economicSourceId = []
            }
            if (this.addForm.elderlyCategory != null) {
              this.oldManId = this.addForm.elderlyCategory.split(",")
            } else {
              this.oldManId = []
            }
            if (this.addForm.expectPensionModel != null) {
              this.expectPensionId = this.addForm.expectPensionModel.split(",")
            } else {
              this.expectPensionId = []
            }
            if (this.addForm.expectService != null) {
              this.expectServiceId = this.addForm.expectService.split(",")
            } else {
              this.expectServiceId = []
            }
            this.addForm.dataId = String(this.addForm.dataId)
            
            this.$http
              .request({
                url: "/jjyl/admin/customerSign/info/get",
                method: "POST",
                data: {
                  customerId: val.id,
                },
              })
              .then((res) => {
                if (res.code === 200) {
                  this.historyList = res.content || []
                }
              })
            this.$forceUpdate()
          }
          if (val.hide) {
            ;(this.hobbyId = []),
              (this.economicSourceId = []),
              (this.serviceCategory = []),
              (this.goverInfoId = [])
            this.addForm = {
              address: "",
              familyContact: [
                {
                  contactName: "",
                  relation: "",
                  gender: "",
                  liveTogether: "",
                  phone: "",
                  sparePhone: "",
                  address: "",
                  photo: "",
                },
              ],
              contact: [
                {
                  contactName: "",
                  relation: "",
                  gender: "",
                  liveTogether: "",
                  phone: "",
                  sparePhone: "",
                  address: "",
                  photo: "",
                },
              ],
              customerHealth: {},
              yptCustomerId: "",
            }
            this.hobbyId =
              this.serviceCategory =
              this.economicSourceId =
              this.goverInfoId =
              this.oldManId =
              this.expectPensionId =
              this.expectServiceId =
                []
          }
        })
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.hobbyId = []
    this.serviceCategory = []
    this.economicSourceId = []
    this.goverInfoId = []
    if (this.setTitle == "新增") {
      this.addForm = {
        customerName: "",
        address: "",
        dataId: [],
        yptCustomerId: "",
        familyContact: [
          {
            contactName: "",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ],
        contact: [
          {
            contactName: "",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ],
      }
    } else {
      this.addForm = this.formData
    }
    this.getTreeChecked()
    // this.getTree()
    this.getOrg()

    this.$http
      .request({
        url: "/jjyl/admin/community/info/CommunityTree",
        method: "POST",
        data: {},
      })
      .then((res) => {
        if (res.code === 200) {
          this.selectTreeList = res.content
        }
      })
    this.gettypeList()
    this.getusertypeList()
    if (this.setTitle == "编辑") {
      //  this.wCustomerInfo()
    }
  },
  methods: {
    //获取服务类别
    getServiceType() {
      return new Promise((resolve, reject) => {
        this.$http
          .request({
            url: "/jjyl/admin/type/info/findList",
            method: "POST",
            data: { pageNo: 1, pageSize: 10, status: 1 },
          })
          .then((res) => {
            if (res.code == 200) {
              // this.getProvince()
              if (res.content == null || res.content == "null") {
                resolve([])
              } else {
                this.serviceType = res.content.list.map((item) => {
                  return {
                    id: String(item.id), //id
                    serviceTypeName: item.serviceTypeName,
                  }
                })
                resolve(this.serviceType)
              }
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    gettypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
            }
          }
        })
    },
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    // 二维码
    getCode() {
      this.codeState = true
    },
    getPicture() {
      this.codeState = false
    },
    getchangeList(query, query1) {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findListAccurately",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            customerName: query,
            idCard: query1,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.options = res.content.list
            } else {
              this.options = []
            }
            this.loading = false
          }
        })
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList(query, "")
      } else {
        this.options = []
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList("", query)
      } else {
        this.options = []
      }
    },
    async handleSelect(val) {
      this.options.forEach((item) => {
        if (item.id == val) {
          this.addForm = JSON.parse(JSON.stringify(item))
          this.addForm.yptCustomerId = val
          exportVue.$emit("health", val)
          exportVue.$emit("oldInfo", val)
        }
      })
      this.addForm.address = this.addForm.address
      this.addForm.customerName = this.addForm.customerName
      this.addForm.dataId = this.addForm.dataId.toString()
      if (this.addForm.customerType != null) {
        this.addForm.customerType = this.addForm.customerType.split(",")
      }
      for (let i in this.addForm.customerType) {
        this.addForm.customerType[i] = Number(this.addForm.customerType[i])
      }
      if (this.addForm.goverInfoId != null) {
        this.goverInfoId = this.addForm.goverInfoId.split(",")
      }
      if (this.addForm.economicSource != null) {
        this.economicSourceId = this.addForm.economicSource.split(",")
      }
      if (this.addForm.hobby != null) {
        this.hobbyId = this.addForm.hobby.split(",")
      }
      if (this.addForm.goverInfoId != null) {
        this.goverInfoId = this.addForm.goverInfoId.split(",")
      }
      if (this.addForm.elderlyCategory != null) {
        this.oldManId = this.addForm.elderlyCategory.split(",")
      }
      if (this.addForm.serviceCategory != null) {
        this.serviceCategory = this.addForm.serviceCategory.split(",")
      }
      if (this.addForm.expectPensionModel != null) {
        this.expectPensionId = this.addForm.expectPensionModel.split(",")
      }
      if (this.addForm.expectService != null) {
        this.expectServiceId = this.addForm.expectService.split(",")
      }

      this.wCustomerInfo()
    },
    //监控姓名是否为空
    clearForm(val) {
      if (val) {
        if (this.setTitle == "新增") {
          this.addForm = {}
          this.goverInfoId = []
          ;(this.economicSourceId = []), (this.hobbyId = [])
          this.changeFirst()
        }
      }
    },
    //监控身份证是否为空
    clearForm1(val) {
      if (val) {
        if (this.setTitle == "新增") {
          this.addForm = {}
          this.goverInfoId = []
          ;(this.economicSourceId = []), (this.hobbyId = [])
          this.changeFirst()
        }
      }
    },
    // 获取机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      let province = await this.getDistrict()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistrict(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getStreetList(this.normalInfo.cityId)
        this.areaList = areaList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      //
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getStreetList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.longitude && this.normalInfo.longitude) {
        this.addForm.latitude = this.normalInfo.latitude
        this.addForm.longitude = this.normalInfo.longitude
      } else {
        if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
          this.provinceList.forEach((item) => {
            if (item.adcode == this.normalInfo.provinceId) {
              this.addForm.latitude = item.center.lat
              this.addForm.longitude = item.center.lng
            }
          })
        } else if (this.normalInfo.orgLevel == 2) {
          this.cityList.forEach((item) => {
            if (item.adcode == this.normalInfo.cityId) {
              this.addForm.latitude = item.center.lat
              this.addForm.longitude = item.center.lng
            }
          })
        } else if (this.normalInfo.orgLevel == 3) {
          this.areaList.forEach((item) => {
            if (item.adcode == this.normalInfo.areaId) {
              // this.addForm.latitude = item.center.lat
              // this.addForm.longitude = item.center.lng
            }
          })
        } else if (
          this.normalInfo.orgLevel == 4 ||
          this.normalInfo.orgLevel == 5
        ) {
          this.streetList.forEach((item, index) => {
            if (item.addCode == this.normalInfo.streetId) {
              this.addForm.latitude = item.latitude
              this.addForm.longitude = item.longitude
            }
          })
        }
      }
      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.addForm.provinceId = this.normalInfo.provinceId
      this.addForm.cityId = this.normalInfo.cityId
      this.addForm.address = this.addForm.address
      this.addForm.areaId = this.normalInfo.areaId
      this.addForm.streetId = this.normalInfo.streetId
      this.addForm.communityId = this.normalInfo.communityId
      this.potintMap()
      this.$forceUpdate()
    },
    changeFirst1(){

    },
    //街道地址列表
    getStreetList(val) {
      if (val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/addressYpe/info/findList",
              method: "POST",
              data: {
                parentId: val,
                pageNo: 1,
                pageSize: -1,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                this.streetList = res.content.list
                resolve(res.content.list)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {})
      }
    },
    // 社区地址列表
    getCommityList(val) {
      if (val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: val,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                resolve(res.content)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {})
      }
    },
    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }
      return childrenEach(treeData, depth)
    },
    // 树转同级
    loopTree(data, arr) {
      data.forEach((item) => {
        arr.push(item)
        if (Array.isArray(item.children)) {
          this.loopTree(item.children, arr)
        }
      })
    },
    // 地图
    getMap(input) {
      const self = this
      let autoOptions={}
      if(this.isServiceAddress){
          autoOptions = {
          city: self.addForm.areaId1,
          citylimit: true,
          input: input,
        }
      }else{
         autoOptions = {
          city: self.addForm.areaId,
          citylimit: true,
          input: input,
        }
      }
      console.log(autoOptions,'aaa')
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        if(this.isServiceAddress){
          self.addForm.serviceAddress = e.poi.name
          self.addForm.serviceLongitude  = e.poi.location.lng
          self.addForm.serviceLatitude = e.poi.location.lat
        }else{
          self.addForm.address = e.poi.name
           self.addForm.longitude = e.poi.location.lng
           self.addForm.latitude = e.poi.location.lat
        }
        self.potintMap()
      })
    },
    // 打点
    potintMap() {
      console.log('aaa')
       let arr=[]
       if(this.isServiceAddress){
        arr=[Number(this.addForm.serviceLongitude), Number(this.addForm.serviceLatitude)]
       }else{
        arr=[Number(this.addForm.longitude), Number(this.addForm.latitude)]
       }
      var map = new AMap.Map("container3", {
        resizeEnable: true,
        zoom: 8,
        // zooms: [3, 20],
        expandZoomRange: true,
        center: arr,
      })
      var marker = new AMap.Marker({
        position: arr,
        map: map,
      })
      map.setFitView(marker)
    },
    // 身份证获取信息
    idCardchange(val) {
      //出生年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.addForm.birthday = birthday
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.addForm.age = age
      if (parseInt(val.substr(16, 1)) % 2 == 1) {
        this.addForm.gender = "0"
        //是男则执行代码 ...
      } else {
        this.addForm.gender = "1"
        //是女则执行代码 ...
      }
    },
    getTreeChecked(id) {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    // 上传照片
    handleAvatarSuccess(res, file) {
      if (res.code === 200 && res.content) {
        this.$set(this.addForm, "photo", res.content)
        this.wCustomerInfo()
      }
    },
    // 上传直系亲属紧急联系人照片
    immediateFamilyA(res, index) {
      if (res.code === 200 && res.content) {
        this.$set(this.addForm.familyContact[index], "photo", res.content)
        this.wCustomerInfo()
      }
    },
    // 上传紧急联系人照片
    emergencyContactA(res, index) {
      if (res.code === 200 && res.content) {
        this.$set(this.addForm.contact[index], "photo", res.content)
        this.wCustomerInfo()
      }
    },
    emergencyContactB(res, file) {
      if (res.code === 200 && res.content) {
        this.$set(this, "imageUrl", res.content)
        this.wCustomerInfo()
      }
    },
    //个人喜好
    checkedHobby(val) {
      this.$set(this.addForm, "hobby", val.join(","))
      this.wCustomerInfo()
    },
    //服务类别
    checkedGory(val) {
      this.$set(this.addForm, "serviceCategory", val.join(","))
      this.wCustomerInfo()
    },
    //经济来源
    changeEconomicSource(val) {
      this.$set(this.addForm, "economicSource", val.join(","))
      this.wCustomerInfo()
    },
    //政府援助
    changeGover(val) {
      this.$set(this.addForm, "goverInfoId", val.join(","))
      this.wCustomerInfo()
    },
    //老人类别
    getElderlyCategory(val) {
      this.$set(this.addForm, "elderlyCategory", val.join(","))
      this.wCustomerInfo()
    },
    //期望养老模式
    changeExpectPension(val) {
      this.$set(this.addForm, "expectPensionModel", val.join(","))
      this.wCustomerInfo()
    },
    //期望的服务
    changeExpectService(val) {
      this.$set(this.addForm, "expectService", val.join(","))
      this.wCustomerInfo()
    },
    //添加直系亲属
    addimmediate() {
      this.addForm.familyContact.push({
        contactName: "",
        relation: "",
        gender: "",
        liveTogether: "",
        phone: "",
        sparePhone: "",
        address: "",
        photo: "",
      })
    },
    //添加紧急联系人
    addUrgency() {
      if (this.addForm.contact == null || this.addForm.contact == "null") {
        this.addForm.contact = [
          {
            contactName: "",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ]
      } else {
        this.addForm.contact.push({
          contactName: "",
          relation: "",
          gender: "",
          liveTogether: "",
          phone: "",
          sparePhone: "",
          address: "",
          photo: "",
        })
      }
    },
    chioceId(id) {
      this.tapId = id
      if (
        this.addForm.contact == "undefined" ||
        this.addForm.contact == undefined
      ) {
        this.addForm.contact = [
          {
            contactName: "",
            relation: "",
            gender: "",
            liveTogether: "",
            phone: "",
            sparePhone: "",
            address: "",
            photo: "",
          },
        ]
      }
    },
    wCustomerInfo() {
      this.$emit("customerData", this.addForm)
    },

    async chioceDizhi() {
      this.dialogVisible = true
      this.isServiceAddress=false
      await this.$nextTick(function () {
        this.loadMap().then((res) => {
          this.getProvince()
        })
      })
      await this.getProvince()
      if (this.setTitle == "新增") {
        this.addForm.address = ""
        await this.changeFirst()
      } else {
        this.potintMap()
        if (!this.addForm.provinceId) return
        this.$set(this.addForm, "provinceId", String(this.addForm.provinceId))
        let city = await this.getDistrict(this.addForm.provinceId)
        this.cityList = city.districtList
        if (!this.addForm.cityId) return
        this.$set(this.addForm, "cityId", String(this.addForm.cityId))
        let area = await this.getStreetList(this.addForm.cityId)
        this.areaList = area
        if (!this.addForm.areaId) return
        this.$set(this.addForm, "areaId", String(this.addForm.areaId))
        let street = await this.getStreetList(this.addForm.areaId)
        this.streetList = street
        if (!this.addForm.streetId) return
        this.$set(this.addForm, "streetId", String(this.addForm.streetId))
        let communityList = await this.getStreetList(this.addForm.streetId)
        this.communityList = communityList
        this.$set(this.addForm, "communityId", Number(this.addForm.communityId))
      }
    },
    async chioceDizhi1(){
       this.dialogVisible1=true
       this.isServiceAddress=true
        await this.$nextTick(function () {
          this.loadMap().then((res) => {
            this.getProvince()
          })
      })
       if(this.setTitle=='新增'){
         this.addForm.provinceId1=''
         this.addForm.cityId1=''
         this.addForm.streetId1=''
         this.addForm.areaId1=''
       }else{
          this.potintMap()
          if (!this.addForm.provinceId1) return
          this.$set(this.addForm, "provinceId1", String(this.addForm.provinceId1))
          let city = await this.getDistrict(this.addForm.provinceId1)
          this.cityList = city.districtList
          if (!this.addForm.cityId1) return
          this.$set(this.addForm, "cityId1", String(this.addForm.cityId1))
          let area = await this.getStreetList(this.addForm.cityId1)
          this.areaList = area
          if (!this.addForm.areaId1) return
          this.$set(this.addForm, "areaId1", String(this.addForm.areaId1))
          let street = await this.getStreetList(this.addForm.areaId1)
          this.streetList = street
          if (!this.addForm.streetId1) return
          this.$set(this.addForm, "streetId1", String(this.addForm.streetId1))
          let communityList = await this.getStreetList(this.addForm.streetId1)
          this.communityList = communityList
          this.$set(this.addForm, "communityId1", Number(this.addForm.communityId1))
       }
       
    },
    cleatLat() {
      this.$http
        .request({
          url: "/jjyl/admin/center/customer/info/clearLat",
          method: "POST",
          data: {
            id: this.addForm.id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("清除经纬度成功")
          }
        })
    },
    cleatLat1(){
       this.addForm.serviceLongitude =''
      this.addForm.serviceLatitude =''
    },
    locationClose() {
      this.dialogVisible = false
      this.dialogVisible1 = false
    },
    //选择位置
    locationSend() {
      if(this.isServiceAddress){
        this.dialogVisible1 = false
        this.$nextTick(() => {
            let shengName = this.$refs.selectShengChange.selectedLabel
            let shiName = this.$refs.selectShiChange.selectedLabel
            let quName = this.$refs.selectQuChange.selectedLabel
            let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
            let shequName = this.$refs.selectShequChange.selectedLabel
            if (shequName == "") {
              this.addForm.serviceAddress =
                shengName +
                "-" +
                shiName +
                "-" +
                quName +
                "-" +
                jiedaoName +
                "-" +
                this.addForm.serviceAddress
            } else {
              this.addForm.address =
                shengName +
                "-" +
                shiName +
                "-" +
                quName +
                "-" +
                jiedaoName +
                "-" +
                shequName +
                "-" +
                this.addForm.address
            }
          })
      }else{
        this.dialogVisible = false
           this.$nextTick(() => {
            let shengName = this.$refs.selectShengChange.selectedLabel
            let shiName = this.$refs.selectShiChange.selectedLabel
            let quName = this.$refs.selectQuChange.selectedLabel
            let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
            let shequName = this.$refs.selectShequChange.selectedLabel
            if (shequName == "") {
              this.addForm.address =
                shengName +
                "-" +
                shiName +
                "-" +
                quName +
                "-" +
                jiedaoName +
                "-" +
                this.addForm.address
            } else {
              this.addForm.address =
                shengName +
                "-" +
                shiName +
                "-" +
                quName +
                "-" +
                jiedaoName +
                "-" +
                shequName +
                "-" +
                this.addForm.address
            }
          })
        }
      this.wCustomerInfo()
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },

    // 加入地址图片
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        //
        if (!address) {
          if(this.isServiceAddress){
             self.serviceAddress = shengName + shiName + quName + jiedaoName + shequName
          }else{
               self.address = shengName + shiName + quName + jiedaoName + shequName
          }
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        let address=''
        if(this.serviceAddress){
          address=this.serviceAddress
        }else{
          address=this.address
        }
        geocoder.getLocation(address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            if(this.serviceAddress){
              self.addForm.serviceLongitude = lnglat.lng
               self.addForm.serviceLatitude = lnglat.lat
               self.marker.setPosition(lnglat)
               self.myMap.add(self.marker)
               self.myMap.setFitView(self.marker)
            }else{
                self.addForm.longitude = lnglat.lng
               self.addForm.latitude = lnglat.lat
               self.marker.setPosition(lnglat)
               self.myMap.add(self.marker)
               self.myMap.setFitView(self.marker)
            }
           
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      if(this.isServiceAddress){
        this.addForm.cityId1 = ""
      }
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) { 
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
     
      this.addForm.communityList = ""
      if(this.isServiceAddress){
        this.addForm.serviceAddress=''
         this.addForm.cityId1 = ""
         this.addForm.areaId1 = ""
        this.addForm.streetId1 = ""
      }else{
        this.addForm.address = ""
         this.addForm.cityId = ""
         this.addForm.areaId = ""
         this.addForm.streetId = ""
      }
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      console.log(this.cityList,'this.cityList')
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.communityList = ""
       if(this.isServiceAddress){
        this.addForm.serviceAddress=''
        this.addForm.areaId1 = ""
      this.addForm.streetId1 = ""
      }else{
        this.addForm.address = ""
        this.addForm.areaId = ""
       this.addForm.streetId = ""
      }
      let area = await this.getStreetList(val)
      this.areaList = area
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
    //  this.streetList =[]
      this.communityList = []
       if(this.isServiceAddress){
        this.addForm.serviceAddress=''
         this.addForm.streetId1 = ""
      }else{
        this.addForm.address = ""
         this.addForm.streetId = ""
        this.addForm.communityList = ""
      }
      // val = val.replace(/.$/, "");
      let streetList = await this.getStreetList(val)
      this.streetList = streetList
      this.joinAddress()
    },
    //街道地址发生变化
    async streetChange(val) {
       console.log(this.streetList,'this.streetList')
      let communityList = await this.getStreetList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },

    //加载地图
    loadMap() {
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map("container3", {
          resizeEnable: true,
          zoom: 9,
        })

        resolve()
      })
    },
  },
}
</script>

<style lang="less" scoped>
.right-1 {
  width: 98%;
  margin-left: 2%;
  display: flex;
}

.right-1 > div {
  width: 33.33%;
}

.right-title-1 {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
  .overs {
    /deep/.el-select__tags {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap !important;
    }
  }
}

.right-title-2 {
  border-top: 1px solid #c0c4cc;
}

.right-title-3 {
  border-right: 1px solid #c0c4cc;
}

.right-title-1 > div:first-child {
  width: 131px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-1 > div:nth-child(2) {
  height: 40px;
  line-height: 40px;
  width: calc(100% - 10px);

  /deep/ .el-input__inner {
    border: none;
  }
}

.right-2 {
  width: 100%;
  display: flex;
  margin: 20px 0 34px 0;
  justify-content: center;
}

.shangchuang {
  width: 178px;

  margin-top: 20px;
  text-align: center;
}
.shangchuang2 {
  display: flex;
  margin-top: 20px;
  text-align: center;
  .item {
    flex: 1;
    height: 30px;
    cursor: pointer;
    line-height: 30px;
    border-radius: 5px;
    color: #ffffff;
    background-color: #0000ff;
    &.item1 {
      margin-left: 12px;
    }
  }
}

.bottom-1 {
  width: 98%;
  margin-left: 2%;
}

.bottom-1 > div:first-child {
  width: 100%;
}

.right-title-5 {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
}

.right-title-5 > div:first-child {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-4 {
  width: calc(100% - 100px);
  display: flex;
  align-items: center;
}

.right-title-4 > div:first-child {
  margin-left: 20px;
}

.map_container {
  margin-top: 12px;
  display: flex;

  .map_left {
    box-sizing: border-box;
    margin-right: 10px;
    width: 260px;
    height: 300px;
    padding: 12px;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: 5px;

    p {
      line-height: 42px;
      text-align: center;
    }
  }

  .map_right {
    width: 100%;
    height: 300px;
  }
}

.right-title-4 > div:nth-child(2) {
  margin-left: 10px;
  width: 200px;
}

.right-title-6 {
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
}

.right-title-6 > div:first-child {
  width: 100px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-7 {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  // justify-content: space-between;
  border-bottom: 1px solid #c0c4cc;
}

.right-title-7 > div:first-child {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-7 > div:nth-child(2) {
  width: calc(100% - 250px);

  /deep/ .el-input__inner {
    border: none;
  }
}

.colorIcon {
  color: #0000ff;
  font-size: 30px;
}

.right-title-8 {
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
}

.right-title-8 > div:first-child {
  width: 100px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-8 > div:nth-child(2) {
  width: calc(100% - 100px);

  /deep/ .el-textarea__inner {
    border: none;
    resize: none;
  }
}

.list-1 {
  width: 100%;
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
}

.list-2 {
  width: 150px;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  background-color: #aaaaaa;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}

.change {
  background-color: #0000ff;
}

.right-title-9 {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
  border-right: 1px solid #c0c4cc;
}

.right-title-9 > div:first-child {
  width: 100px;
  padding: 20px 0;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}

.right-title-9 > div:nth-child(2) {
  margin-left: 20px;
}

.tap2-1 {
  width: 100%;
  display: flex;
}

.tap2-1 > div:first-child {
  width: 65%;
  margin: 20px 0;
  margin-right: 5%;
}

.tap2-1 > div:nth-child(2) {
  width: 30%;
}

.tap2-2 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.tap2-3 {
  width: 48%;
  display: flex;
  align-items: center;
}

.tap2-3 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap2-3 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.tap2-4 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.tap2-4 > div:first-child {
  width: 100px;
  text-align: right;
}

.tap2-4 > div:nth-child(2) {
  width: calc(100% - 100px);
}

.shangchuang1 {
  width: 128px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  color: #ffffff;
  margin-top: 15px;
  text-align: center;
  background-color: #0000ff;
}

.tap4-2 {
  font-size: 12px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar1 {
  width: 128px;
  height: 128px;
  display: block;
}

#myPageTop {
  position: absolute;
  top: -50px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  margin: 10px auto;
  padding: 6px;
  font-size: 14px;
}
</style>
